// TODO: re-export box from skooldio qms ui
import { Box, BoxProps } from '@mui/material';

export default Box;
export type { BoxProps };
